/** Number of Teams seats for the free tier */
export const DEFAULT_TEAM_SEATS = 5;

/**
 * Cap on photos per gallery. Enforced server-side by the Firestore rule on `/galleries`
 * updates; mirrored client-side in `AddItemsToGalleryInteractor` for a friendlier error
 * message. Keep this in sync with `firestore.rules`.
 */
export const MAX_GALLERY_ITEMS = 1000;

/** Default page size for the paginated gallery viewer + management grid. */
export const GALLERY_PAGE_SIZE = 60;

/** Hard upper bound the server enforces on a requested page size. */
export const GALLERY_MAX_PAGE_SIZE = 100;

/**
 * Server-side timeout, in minutes, for the functions that add Team members in
 * bulk (`addTeamMembers`, `syncTeamGroupUsers`). Every imported user costs a
 * handful of Firestore reads plus a couple of storage-provider round trips
 * (creating and sharing their default Album), and they are processed serially,
 * so a large CSV import runs for many minutes.
 */
export const BULK_ADD_TEAM_MEMBERS_TIMEOUT_MINUTES = 30;

/**
 * Client-side timeout, in ms, for the same calls. The Firebase SDK defaults to
 * 70s and rejects the caller with `deadline-exceeded` while the function keeps
 * running to completion server-side, so the admin sees an error and loses the
 * import report even though the users were added. Must cover the server-side
 * timeout plus a margin for the response to travel back.
 */
export const BULK_ADD_TEAM_MEMBERS_CLIENT_TIMEOUT_MS =
  (BULK_ADD_TEAM_MEMBERS_TIMEOUT_MINUTES + 1) * 60 * 1000;
